import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import LockFingerprint from 'src/assets/img/LockFingerprint.png'

import Login from 'src/ui/templates/Login'
import WrappedInput from 'src/ui/atoms/Input/Wrapped'
import Button from 'src/ui/atoms/Button'

import useForgotPasswordApi, { IForgotPasswordCredentials } from './useForgotPasswordApi'

const ForgotPassword = () => {
  const navigate = useNavigate()
  const { forgotPassword } = useForgotPasswordApi()

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
  })

  const handleForgotPassword = async ({ email }: IForgotPasswordCredentials) => {
    const credentials = {
      email,
    }
    try {
      await forgotPassword(credentials)

      navigate('/login')
    } catch (err) {
      console.error('Forgot password error', err)
    }
  }

  return (
    <Login leftContent={LockFingerprint}>
      <div className="flex h-full flex-col justify-between gap-6">
        <h1 className="text-center text-white">Recover your password</h1>
        <span className="text-center text-lg text-white">
          We'll send you a link on mail with instructions to reset your password and get back on
          track.
        </span>
        <form
          className="grid gap-6"
          onSubmit={handleSubmit((data) =>
            handleForgotPassword(data as IForgotPasswordCredentials),
          )}>
          <div className="grid gap-4">
            <WrappedInput
              placeholder="your_email@mail.com"
              label="Email"
              error={errors.email}
              labelPosition="inside"
              type="email"
              dataCy="email"
              {...register('email', {
                required: 'Required field',
                pattern: { value: /^\S+@\S+$/i, message: 'Incorrect email' },
              })}
            />
          </div>
          <Button name="Send link" disabled={!isValid} dataCy="send-link" />
        </form>
        <span className="text-white">
          By sending link you agree to the{' '}
          <a
            className="text-main-blue"
            target="_blank"
            href="//zoidcore.com/terms-and-conditions.html"
            rel="noreferrer">
            Terms of use
          </a>{' '}
          and{' '}
          <a
            className="text-main-blue"
            target="_blank"
            href="//zoidcore.com/privacy-policy.html"
            rel="noreferrer">
            Privacy Policy
          </a>
        </span>
      </div>
    </Login>
  )
}

export default ForgotPassword
